import type { FC } from "react";
import { useIntl } from "react-intl";
import { UsageCard, type UsageCardLoaderProps } from "./UsageCard.js";
import { calculateUsageCost, TieredPriceProductId } from "@project/common";
import { IconChartLine } from "@tabler/icons-react";
import { INTERNATIONALIZED_UNIT_LABELS } from "../../../constants/productLabels.js";
import { useStyleJsonUsageSum } from "./hooks/fetchSums.js";
import { useProductDescriptions, useProductNames } from "./hooks/productLabels.js";

export const MapLoadsUsageCard: FC<UsageCardLoaderProps> = ({
  from,
  to,
  interval,
  apiKeyId,
  productId,
  isLoadingSubscriptions,
}) => {
  const intl = useIntl();
  const getName = useProductNames();
  const getDescription = useProductDescriptions();
  const {
    usageSum,
    isLoadingStyleJsonUsage,
    isErrorStyleJsonUsage,
  } = useStyleJsonUsageSum({ from, to, interval, apiKeyId });

  const unitLabel = intl.formatMessage(
    INTERNATIONALIZED_UNIT_LABELS["1000_requests"],
  );

  return (
    <UsageCard
      productId={productId}
      usageSum={usageSum}
      unitLabel={unitLabel}
      icon={<IconChartLine />}
      iconColor="orange.8"
      isError={isErrorStyleJsonUsage}
      name={getName(TieredPriceProductId.TieredMapSession)}
      description={getDescription(TieredPriceProductId.TieredMapSession)}
      isLoading={isLoadingSubscriptions || isLoadingStyleJsonUsage}
      usageCost={calculateUsageCost(usageSum, productId)}
      defaultProductId={TieredPriceProductId.TieredMapSession}
    />
  );
};
